import { Header } from '@Components/StickyTable/BPMTable';
import { MAP_ASPECT_RATIO } from '@Components/DmaMap/dma-map-constants';

// Display order for the lag dropdown; /geo_lags results are filtered against this, so lags without a
// LAG_NAMES label are dropped.
export const LAGS = ['1d', '3d', '7d', '14d', '30d', 'all_business'] as const;
export type Lag = (typeof LAGS)[number];

export const LAG_NAMES: Record<Lag, string> = {
  '1d': '1 Day',
  '3d': '3 Days',
  '7d': '7 Days',
  '14d': '14 Days',
  '30d': '30 Days',
  all_business: 'Overall Business'
};

export const DEFAULT_LAG: Lag = '7d';

export const IMPRESSIONS_CUTOFF_PERCENTAGE = 0.0005;
// Defines the range of captured values in terms of the standard deviation
export const COLOR_RANGE_SENSITIVITY = 2;

// Fill for DMAs below the impressions cutoff; no palette equivalent.
export const DISABLED_COLOR = '#F2F2F2';

export const DOWNLOAD_WIDTH = 1000;
export const DOWNLOAD_HEIGHT = DOWNLOAD_WIDTH / MAP_ASPECT_RATIO;

export const TABLE_HEADERS: Header[] = [
  { name: 'name', label: 'DMA Name', width: 170 },
  { name: 'dma', label: 'Code', width: 60 },
  { name: 'index', label: 'Index', width: 60 },
  { name: 'impressions', label: 'Impressions', flex: 1 },
  { name: 'responses', label: 'Responses', flex: 1 },
  { name: 'households', label: 'Households', flex: 1 }
];
